// // src/views/Inventory.jsx - FIXED VERSION
// import React, { useState, useEffect } from 'react';
// import api from '../api';

// export default function Inventory() {
//   const [activeTab, setActiveTab] = useState('ingredients');
//   const [ingredients, setIngredients] = useState([]);
//   const [recipes, setRecipes] = useState([]);
//   const [menuItems, setMenuItems] = useState([]);

//   // ✅ FIX: Proper default values for ingredient form
//   const [ingredientForm, setIngredientForm] = useState({
//     name: '',
//     unit: 'kg',
//     quantity: 0,      // Default to 0, not undefined
//     minThreshold: 5   // Default to 5, not undefined
//   });

//   const [recipeForm, setRecipeForm] = useState({
//     menuItem: '',
//     ingredients: []
//   });

//   const [editingId, setEditingId] = useState(null);
//   const [editingRecipeId, setEditingRecipeId] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');

//   useEffect(() => {
//     fetchIngredients();
//     fetchRecipes();
//     fetchMenuItems();
//   }, []);

//   const fetchIngredients = async () => {
//     try {
//       const res = await api.get('/inventory/ingredients');
//       setIngredients(res.data);
//     } catch (err) {
//       console.error('Error fetching ingredients:', err);
//       setError('Failed to fetch ingredients');
//     }
//   };

//   const fetchRecipes = async () => {
//     try {
//       const res = await api.get('/inventory/recipes');
//       setRecipes(res.data);
//     } catch (err) {
//       console.error('Error fetching recipes:', err);
//     }
//   };

//   const fetchMenuItems = async () => {
//     try {
//       const res = await api.get('/menu');
//       setMenuItems(res.data);
//     } catch (err) {
//       console.error('Error fetching menu items:', err);
//     }
//   };

//   // ✅ FIX: Proper handling of number inputs
//   const handleIngredientChange = (field, value) => {
//     setIngredientForm(prev => {
//       if (field === 'quantity' || field === 'minThreshold') {
//         // Convert to number, default to 0 if empty or invalid
//         const numValue = value === '' ? 0 : parseFloat(value);
//         return {
//           ...prev,
//           [field]: isNaN(numValue) ? 0 : numValue
//         };
//       }
//       return {
//         ...prev,
//         [field]: value
//       };
//     });
//   };

//   const handleSaveIngredient = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setError('');

//     try {
//       // ✅ Ensure all numbers are valid before sending
//       const dataToSend = {
//         name: ingredientForm.name,
//         unit: ingredientForm.unit,
//         quantity: Number(ingredientForm.quantity) || 0,
//         minThreshold: Number(ingredientForm.minThreshold) || 5
//       };

//       console.log('Saving ingredient:', dataToSend);

//       if (editingId) {
//         await api.put(`/inventory/ingredients/${editingId}`, dataToSend);
//       } else {
//         await api.post('/inventory/ingredients', dataToSend);
//       }

//       // Reset form with proper defaults
//       setIngredientForm({
//         name: '',
//         unit: 'kg',
//         quantity: 0,
//         minThreshold: 5
//       });
//       setEditingId(null);
//       fetchIngredients();
//     } catch (err) {
//       console.error('Error saving ingredient:', err);
//       setError(err.response?.data?.message || 'Failed to save ingredient');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleEditIngredient = (ingredient) => {
//     setIngredientForm({
//       name: ingredient.name,
//       unit: ingredient.unit,
//       quantity: ingredient.quantity || 0,
//       minThreshold: ingredient.minThreshold || 5
//     });
//     setEditingId(ingredient._id);
//   };

//   const handleDeleteIngredient = async (id) => {
//     if (!window.confirm('Are you sure you want to delete this ingredient?')) return;

//     try {
//       await api.delete(`/inventory/ingredients/${id}`);
//       fetchIngredients();
//     } catch (err) {
//       console.error('Error deleting ingredient:', err);
//       setError('Failed to delete ingredient');
//     }
//   };



//   const handleUpdateStock = async (id, addedQuantity) => {
//   try {
//     const numValue = Number(addedQuantity);
//     if (isNaN(numValue) || numValue <= 0) {
//       setError('Please enter a valid positive quantity to add');
//       return;
//     }

//     // Find the current ingredient
//     const current = ingredients.find(i => i._id === id);
//     if (!current) {
//       setError('Ingredient not found');
//       return;
//     }

//     // ✅ Add new quantity instead of replacing
//     const newTotal = current.quantity + numValue;

//     await api.put(`/inventory/ingredients/${id}/stock`, { 
//       quantity: newTotal 
//     });

//     fetchIngredients();
//   } catch (err) {
//     console.error('Error updating stock:', err);
//     setError('Failed to update stock');
//   }
// };


//   // Recipe handlers remain the same...
//   const handleAddRecipeIngredient = () => {
//     setRecipeForm(prev => ({
//       ...prev,
//       ingredients: [...prev.ingredients, { ingredient: '', quantity: 0 }]
//     }));
//   };

//   const handleRecipeIngredientChange = (index, field, value) => {
//     setRecipeForm(prev => {
//       const newIngredients = [...prev.ingredients];
//       if (field === 'quantity') {
//         const numValue = parseFloat(value);
//         newIngredients[index][field] = isNaN(numValue) ? 0 : numValue;
//       } else {
//         newIngredients[index][field] = value;
//       }
//       return { ...prev, ingredients: newIngredients };
//     });
//   };

//   const handleRemoveRecipeIngredient = (index) => {
//     setRecipeForm(prev => ({
//       ...prev,
//       ingredients: prev.ingredients.filter((_, i) => i !== index)
//     }));
//   };

//   const handleSaveRecipe = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setError('');

//     try {
//       if (!recipeForm.menuItem) {
//         setError('Please select a menu item');
//         setLoading(false);
//         return;
//       }

//       if (recipeForm.ingredients.length === 0) {
//         setError('Please add at least one ingredient');
//         setLoading(false);
//         return;
//       }

//       const validIngredients = recipeForm.ingredients
//         .filter(ing => ing.ingredient && ing.quantity > 0)
//         .map(ing => ({
//           ingredient: ing.ingredient,
//           quantity: Number(ing.quantity)
//         }));

//       if (validIngredients.length === 0) {
//         setError('Please add valid ingredients with quantities');
//         setLoading(false);
//         return;
//       }

//       if (editingRecipeId) {
//         // Update existing recipe
//         await api.put(`/inventory/recipes/${editingRecipeId}`, {
//           menuItem: recipeForm.menuItem,
//           ingredients: validIngredients
//         });
//       } else {
//         // Create new recipe
//         await api.post('/inventory/recipes', {
//           menuItem: recipeForm.menuItem,
//           ingredients: validIngredients
//         });
//       }

//       setRecipeForm({ menuItem: '', ingredients: [] });
//       setEditingRecipeId(null);
//       fetchRecipes();
//     } catch (err) {
//       console.error('Error saving recipe:', err);
//       setError(err.response?.data?.message || 'Failed to save recipe');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleEditRecipe = (recipe) => {
//     setRecipeForm({
//       menuItem: recipe.menuItem._id,
//       ingredients: recipe.ingredients.map(ing => ({
//         ingredient: ing.ingredient._id,
//         quantity: ing.quantity
//       }))
//     });
//     setEditingRecipeId(recipe._id);
//   };

//   const handleDeleteRecipe = async (id) => {
//     if (!window.confirm('Are you sure you want to delete this recipe?')) return;

//     try {
//       await api.delete(`/inventory/recipes/${id}`);
//       fetchRecipes();
//     } catch (err) {
//       console.error('Error deleting recipe:', err);
//       setError('Failed to delete recipe');
//     }
//   };

//   return (
//     <div className="p-6">
//       <h1 className="text-3xl font-bold mb-6">Inventory Management</h1>

//       {error && (
//         <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4 relative">
//           {error}
//           <button 
//             onClick={() => setError('')} 
//             className="absolute top-0 right-0 px-4 py-3 font-bold"
//           >
//             ×
//           </button>
//         </div>
//       )}

//       {/* Tabs */}
//       <div className="flex border-b mb-6">
//         <button
//           onClick={() => setActiveTab('ingredients')}
//           className={`px-6 py-2 font-medium ${
//             activeTab === 'ingredients'
//               ? 'border-b-2 border-blue-500 text-blue-600'
//               : 'text-gray-500 hover:text-gray-700'
//           }`}
//         >
//           Ingredients
//         </button>
//         <button
//           onClick={() => setActiveTab('recipes')}
//           className={`px-6 py-2 font-medium ${
//             activeTab === 'recipes'
//               ? 'border-b-2 border-blue-500 text-blue-600'
//               : 'text-gray-500 hover:text-gray-700'
//           }`}
//         >
//           Recipes
//         </button>
//       </div>

//       {/* INGREDIENTS TAB */}
//       {activeTab === 'ingredients' && (
//         <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          
//           {/* Add/Edit Form */}
//           <div className="bg-white p-6 rounded-lg shadow">
//             <h2 className="text-xl font-semibold mb-4">
//               {editingId ? 'Edit Ingredient' : 'Add Ingredient'}
//             </h2>
            
//             <div className="space-y-4">
//               <div>
//                 <label className="block text-sm font-medium mb-1">Name *</label>
//                 <input
//                   type="text"
//                   value={ingredientForm.name}
//                   onChange={(e) => handleIngredientChange('name', e.target.value)}
//                   className="w-full border rounded px-3 py-2"
//                   required
//                 />
//               </div>

//               <div>
//                 <label className="block text-sm font-medium mb-1">Unit *</label>
//                 <select
//                   value={ingredientForm.unit}
//                   onChange={(e) => handleIngredientChange('unit', e.target.value)}
//                   className="w-full border rounded px-3 py-2"
//                 >
//                   <option value="kg">Kilogram (kg)</option>
//                   <option value="g">Gram (g)</option>
//                   <option value="l">Liter (l)</option>
//                   <option value="ml">Milliliter (ml)</option>
//                   <option value="pcs">Pieces (pcs)</option>
//                 </select>
//               </div>

//               <div>
//                 <label className="block text-sm font-medium mb-1">Quantity *</label>
//                 <input
//                   type="number"
//                   step="0.01"
//                   min="0"
//                   value={ingredientForm.quantity === 0 ? '' : ingredientForm.quantity}
//                   onChange={(e) => handleIngredientChange('quantity', e.target.value)}
//                   placeholder="Enter quantity"
//                   className="w-full border rounded px-3 py-2"
//                   required
//                 />
//               </div>

//               <div>
//                 <label className="block text-sm font-medium mb-1">Min Threshold *</label>
//                 <input
//                   type="number"
//                   step="0.01"
//                   min="0"
//                   value={ingredientForm.minThreshold}
//                   onChange={(e) => handleIngredientChange('minThreshold', e.target.value)}
//                   className="w-full border rounded px-3 py-2"
//                   required
//                 />
//               </div>

//               <div className="flex gap-2">
//                 <button
//                   onClick={handleSaveIngredient}
//                   disabled={loading}
//                   className="flex-1 bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 disabled:bg-gray-400"
//                 >
//                   {loading ? 'Saving...' : editingId ? 'Update' : 'Add'}
//                 </button>
//                 {editingId && (
//                   <button
//                     onClick={() => {
//                       setEditingId(null);
//                       setIngredientForm({ name: '', unit: 'kg', quantity: 0, minThreshold: 5 });
//                     }}
//                     className="px-4 py-2 border rounded hover:bg-gray-100"
//                   >
//                     Cancel
//                   </button>
//                 )}
//               </div>
//             </div>
//           </div>

//           {/* Ingredients List */}
//           <div className="bg-white p-6 rounded-lg shadow">
//             <h2 className="text-xl font-semibold mb-4">Current Stock</h2>
//             <div className="space-y-3 max-h-[600px] overflow-y-auto">
//               {ingredients.map((ing) => (
//                 <div
//                   key={ing._id}
//                   className={`border rounded p-4 ${
//                     ing.quantity <= ing.minThreshold ? 'border-red-500 bg-red-50' : ''
//                   }`}
//                 >
//                   <div className="flex justify-between items-start mb-2">
//                     <div className="flex-1">
//                       <h3 className="font-semibold">{ing.name}</h3>
//                       <p className="text-sm text-gray-600">
//                         Stock: {ing.quantity} {ing.unit}
//                         {ing.quantity <= ing.minThreshold && (
//                           <span className="text-red-600 ml-2">⚠️ Low Stock</span>
//                         )}
//                       </p>
//                       <p className="text-xs text-gray-500">
//                         Min Threshold: {ing.minThreshold} {ing.unit}
//                       </p>
//                     </div>
//                     <div className="flex gap-2">
//                       <button
//                         onClick={() => handleEditIngredient(ing)}
//                         className="text-blue-500 hover:text-blue-700 text-sm"
//                       >
//                         Edit
//                       </button>
//                       <button
//                         onClick={() => handleDeleteIngredient(ing._id)}
//                         className="text-red-500 hover:text-red-700 text-sm"
//                       >
//                         Delete
//                       </button>
//                     </div>
//                   </div>
//                   <div className="flex gap-2 mt-2">
//                     <input
//                       type="number"
//                       step="0.01"
//                       min="0"
//                       placeholder="New quantity"
//                       className="flex-1 border rounded px-2 py-1 text-sm"
//                       id={`stock-input-${ing._id}`}
//                       onKeyPress={(e) => {
//                         if (e.key === 'Enter') {
//                           handleUpdateStock(ing._id, e.target.value);
//                           e.target.value = '';
//                         }
//                       }}
//                     />
//                     <button
//                       onClick={(e) => {
//                         const input = document.getElementById(`stock-input-${ing._id}`);
//                         if (input.value) {
//                           handleUpdateStock(ing._id, input.value);
//                           input.value = '';
//                         }
//                       }}
//                       className="bg-green-500 text-white px-3 py-1 rounded text-sm hover:bg-green-600"
//                     >
//                       Update
//                     </button>
//                   </div>
//                 </div>
//               ))}
//               {ingredients.length === 0 && (
//                 <p className="text-gray-500 text-center py-8">No ingredients yet</p>
//               )}
//             </div>
//           </div>
//         </div>
//       )}

//       {/* RECIPES TAB */}
//       {activeTab === 'recipes' && (
//         <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          
//           {/* Add Recipe Form */}
//           <div className="bg-white p-6 rounded-lg shadow">
//             <h2 className="text-xl font-semibold mb-4">
//               {editingRecipeId ? 'Edit Recipe' : 'Create Recipe'}
//             </h2>
            
//             <div className="space-y-4">
//               <div>
//                 <label className="block text-sm font-medium mb-1">Menu Item *</label>
//                 <select
//                   value={recipeForm.menuItem}
//                   onChange={(e) => setRecipeForm({ ...recipeForm, menuItem: e.target.value })}
//                   className="w-full border rounded px-3 py-2"
//                   disabled={editingRecipeId} 
//                 >
//                   <option value="">Select a menu item</option>
//                   {menuItems.map((item) => (
//                     <option key={item._id} value={item._id}>
//                       {item.name}
//                     </option>
//                   ))}
//                 </select>
//                 {editingRecipeId && (
//                   <p className="text-xs text-gray-500 mt-1">Menu item cannot be changed when editing</p>
//                 )}
//               </div>

//               <div>
//                 <label className="block text-sm font-medium mb-2">Ingredients *</label>
//                 {recipeForm.ingredients.map((ing, index) => {
//                   const selectedIngredient = ingredients.find(i => i._id === ing.ingredient);
//                   return (
//                     <div key={index} className="flex gap-2 mb-2 items-center">
//                       <select
//                         value={ing.ingredient}
//                         onChange={(e) =>
//                           handleRecipeIngredientChange(index, 'ingredient', e.target.value)
//                         }
//                         className="flex-1 border rounded px-2 py-1"
//                       >
//                         <option value="">Select ingredient</option>
//                         {ingredients.map((ingredient) => (
//                           <option key={ingredient._id} value={ingredient._id}>
//                             {ingredient.name}
//                           </option>
//                         ))}
//                       </select>
//                       <input
//                         type="number"
//                         step="0.01"
//                         min="0"
//                         value={ing.quantity}
//                         onChange={(e) =>
//                           handleRecipeIngredientChange(index, 'quantity', e.target.value)
//                         }
//                         placeholder="Qty"
//                         className="w-20 border rounded px-2 py-1"
//                       />
//                       {selectedIngredient && (
//                         <span className="text-sm text-gray-600 w-10">
//                           {selectedIngredient.unit}
//                         </span>
//                       )}
//                       <button
//                         onClick={() => handleRemoveRecipeIngredient(index)}
//                         className="text-red-500 hover:text-red-700 px-2"
//                       >
//                         ✕
//                       </button>
//                     </div>
//                   );
//                 })}
//                 <button
//                   onClick={handleAddRecipeIngredient}
//                   className="text-blue-500 hover:text-blue-700 text-sm mt-2"
//                 >
//                   + Add Ingredient
//                 </button>
//               </div>

//               <button
//                 onClick={handleSaveRecipe}
//                 disabled={loading}
//                 className="w-full bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 disabled:bg-gray-400"
//               >
//                 {loading ? 'Saving...' : editingRecipeId ? 'Update Recipe' : 'Create Recipe'}
//               </button>

//               {editingRecipeId && (
//                 <button
//                   onClick={() => {
//                     setEditingRecipeId(null);
//                     setRecipeForm({ menuItem: '', ingredients: [] });
//                   }}
//                   className="w-full border border-gray-300 px-4 py-2 rounded hover:bg-gray-100"
//                 >
//                   Cancel
//                 </button>
//               )}
//             </div>
//           </div>

//           {/* Recipes List */}
//           <div className="bg-white p-6 rounded-lg shadow">
//             <h2 className="text-xl font-semibold mb-4">Existing Recipes</h2>
//             <div className="space-y-4 max-h-[600px] overflow-y-auto">
//               {recipes.map((recipe) => (
//                 <div key={recipe._id} className="border rounded p-4">
//                   <div className="flex justify-between items-start mb-2">
//                     <h3 className="font-semibold">
//                       {recipe.menuItem?.name || 'Unknown Item'}
//                     </h3>
//                     <div className="flex gap-2">
//                       <button
//                         onClick={() => handleEditRecipe(recipe)}
//                         className="text-blue-500 hover:text-blue-700 text-sm"
//                       >
//                         Edit
//                       </button>
//                       <button
//                         onClick={() => handleDeleteRecipe(recipe._id)}
//                         className="text-red-500 hover:text-red-700 text-sm"
//                       >
//                         Delete
//                       </button>
//                     </div>
//                   </div>
//                   <div className="text-sm text-gray-600">
//                     <p className="font-medium mb-1">Ingredients:</p>
//                     <ul className="list-disc list-inside space-y-1">
//                       {recipe.ingredients.map((ing, idx) => (
//                         <li key={idx}>
//                           {ing.ingredient?.name || 'Unknown'}: {ing.quantity}{' '}
//                           {ing.ingredient?.unit || ''}
//                         </li>
//                       ))}
//                     </ul>
//                   </div>
//                 </div>
//               ))}
//               {recipes.length === 0 && (
//                 <p className="text-gray-500 text-center py-8">No recipes yet</p>
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// src/views/Inventory.jsx - Optimized & Fully Working
import React, { useState, useEffect, useCallback } from 'react';
import api from '../api';

export default function Inventory() {
  const [activeTab, setActiveTab] = useState('ingredients');
  const [ingredients, setIngredients] = useState([]);
  const [recipes, setRecipes] = useState([]);
  const [menuItems, setMenuItems] = useState([]);

  const [ingredientForm, setIngredientForm] = useState({
    name: '',
    unit: 'kg',
    quantity: 0,
    minThreshold: 5
  });

  const [recipeForm, setRecipeForm] = useState({ menuItem: '', ingredients: [] });

  const [editingId, setEditingId] = useState(null);
  const [editingRecipeId, setEditingRecipeId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // ✅ Fetch data on mount
  useEffect(() => {
    fetchIngredients();
    fetchRecipes();
    fetchMenuItems();
  }, []);

  const fetchIngredients = async () => {
    try {
      const res = await api.get('/inventory/ingredients');
      setIngredients(res.data);
    } catch (err) {
      console.error(err);
      setError('Failed to fetch ingredients');
    }
  };

  const fetchRecipes = async () => {
    try {
      const res = await api.get('/inventory/recipes');
      setRecipes(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchMenuItems = async () => {
    try {
      const res = await api.get('/menu');
      setMenuItems(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  // ------------------------------
  // Ingredient Handlers
  // ------------------------------
  const handleIngredientChange = (field, value) => {
    setIngredientForm(prev => ({
      ...prev,
      [field]: field === 'quantity' || field === 'minThreshold'
        ? isNaN(parseFloat(value)) ? 0 : parseFloat(value)
        : value
    }));
  };

  const handleSaveIngredient = async e => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const payload = {
        name: ingredientForm.name,
        unit: ingredientForm.unit,
        quantity: Number(ingredientForm.quantity) || 0,
        minThreshold: Number(ingredientForm.minThreshold) || 5
      };

      if (editingId) {
        await api.put(`/inventory/ingredients/${editingId}`, payload);
        // ✅ Update state instantly
        setIngredients(prev => prev.map(i => i._id === editingId ? { ...i, ...payload } : i));
      } else {
        const res = await api.post('/inventory/ingredients', payload);
        setIngredients(prev => [...prev, res.data]);
      }

      setIngredientForm({ name: '', unit: 'kg', quantity: 0, minThreshold: 5 });
      setEditingId(null);
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || 'Failed to save ingredient');
    } finally {
      setLoading(false);
    }
  };

  const handleEditIngredient = ing => {
    setIngredientForm({
      name: ing.name,
      unit: ing.unit,
      quantity: ing.quantity || 0,
      minThreshold: ing.minThreshold || 5
    });
    setEditingId(ing._id);
  };

  const handleDeleteIngredient = async id => {
    if (!window.confirm('Are you sure you want to delete this ingredient?')) return;
    try {
      await api.delete(`/inventory/ingredients/${id}`);
      setIngredients(prev => prev.filter(i => i._id !== id));
    } catch (err) {
      console.error(err);
      setError('Failed to delete ingredient');
    }
  };

  const handleUpdateStock = async (id, addedQuantity) => {
    const num = Number(addedQuantity);
    if (isNaN(num) || num <= 0) return setError('Enter valid quantity');

    const current = ingredients.find(i => i._id === id);
    if (!current) return setError('Ingredient not found');

    try {
      await api.put(`/inventory/ingredients/${id}/stock`, { quantity: current.quantity + num });
      // ✅ Update state immediately
      setIngredients(prev => prev.map(i => i._id === id ? { ...i, quantity: i.quantity + num } : i));
    } catch (err) {
      console.error(err);
      setError('Failed to update stock');
    }
  };

  // ------------------------------
  // Recipe Handlers
  // ------------------------------
  const handleAddRecipeIngredient = () => {
    setRecipeForm(prev => ({
      ...prev,
      ingredients: [...prev.ingredients, { ingredient: '', quantity: 0 }]
    }));
  };

  const handleRecipeIngredientChange = (index, field, value) => {
    setRecipeForm(prev => {
      const newIngredients = [...prev.ingredients];
      newIngredients[index][field] = field === 'quantity' ? (isNaN(parseFloat(value)) ? 0 : parseFloat(value)) : value;
      return { ...prev, ingredients: newIngredients };
    });
  };

  const handleRemoveRecipeIngredient = index => {
    setRecipeForm(prev => ({
      ...prev,
      ingredients: prev.ingredients.filter((_, i) => i !== index)
    }));
  };

  const handleSaveRecipe = async e => {
    e.preventDefault();
    setLoading(true);
    setError('');

    if (!recipeForm.menuItem) return setError('Select menu item');
    if (recipeForm.ingredients.length === 0) return setError('Add at least one ingredient');

    const validIngredients = recipeForm.ingredients
      .filter(i => i.ingredient && i.quantity > 0)
      .map(i => ({ ingredient: i.ingredient, quantity: i.quantity }));

    if (validIngredients.length === 0) return setError('Add valid ingredients');

    try {
      if (editingRecipeId) {
        await api.put(`/inventory/recipes/${editingRecipeId}`, {
          menuItem: recipeForm.menuItem,
          ingredients: validIngredients
        });
        setRecipes(prev => prev.map(r => r._id === editingRecipeId ? { ...r, ingredients: validIngredients } : r));
      } else {
        const res = await api.post('/inventory/recipes', { menuItem: recipeForm.menuItem, ingredients: validIngredients });
        setRecipes(prev => [...prev, res.data]);
      }
      setRecipeForm({ menuItem: '', ingredients: [] });
      setEditingRecipeId(null);
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || 'Failed to save recipe');
    } finally {
      setLoading(false);
    }
  };

  const handleEditRecipe = recipe => {
    setRecipeForm({
      menuItem: recipe.menuItem._id,
      ingredients: recipe.ingredients.map(i => ({ ingredient: i.ingredient._id, quantity: i.quantity }))
    });
    setEditingRecipeId(recipe._id);
  };

  const handleDeleteRecipe = async id => {
    if (!window.confirm('Are you sure you want to delete this recipe?')) return;
    try {
      await api.delete(`/inventory/recipes/${id}`);
      setRecipes(prev => prev.filter(r => r._id !== id));
    } catch (err) {
      console.error(err);
      setError('Failed to delete recipe');
    }
  };

  // ------------------------------
  // Render
  // ------------------------------
  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold mb-6">Inventory Management</h1>

      {error && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4 relative">
          {error}
          <button onClick={() => setError('')} className="absolute top-0 right-0 px-4 py-3 font-bold">×</button>
        </div>
      )}

      {/* Tabs */}
      <div className="flex border-b mb-6">
        {['ingredients', 'recipes'].map(tab => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`px-6 py-2 font-medium ${activeTab === tab ? 'border-b-2 border-blue-500 text-blue-600' : 'text-gray-500 hover:text-gray-700'}`}
          >
            {tab.charAt(0).toUpperCase() + tab.slice(1)}
          </button>
        ))}
      </div>

      {/* INGREDIENTS */}
      {activeTab === 'ingredients' && (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Form */}
          <div className="bg-white p-6 rounded-lg shadow">
            <h2 className="text-xl font-semibold mb-4">{editingId ? 'Edit Ingredient' : 'Add Ingredient'}</h2>
            <div className="space-y-4">
              {/* {['name','unit','quantity','minThreshold'].map(field => {
                if(field==='unit') return (
                  <div key={field}>
                    <label className="block text-sm font-medium mb-1">Unit *</label>
                    <select value={ingredientForm.unit} onChange={e=>handleIngredientChange('unit', e.target.value)} className="w-full border rounded px-3 py-2">
                      <option value="kg">Kilogram (kg)</option>
                      <option value="g">Gram (g)</option>
                      <option value="l">Liter (l)</option>
                      <option value="ml">Milliliter (ml)</option>
                      <option value="pcs">Pieces (pcs)</option>
                    </select>
                  </div>
                )
                const label = field==='minThreshold'?'Min Threshold':'Quantity';
                return (
                  <div key={field}>
                    <label className="block text-sm font-medium mb-1">{label} *</label>
                    <input
                      type="number"
                      step="0.01"
                      min="0"
                      value={ingredientForm[field] === 0 ? '' : ingredientForm[field]}
                      onChange={e=>handleIngredientChange(field,e.target.value)}
                      className="w-full border rounded px-3 py-2"
                    />
                  </div>
                )
              })} */}
              {['name','unit','quantity','minThreshold'].map(field => {
                if(field==='unit') return (
                  <div key={field}>
                    <label className="block text-sm font-medium mb-1">Unit *</label>
                    <select value={ingredientForm.unit} onChange={e=>handleIngredientChange('unit', e.target.value)} className="w-full border rounded px-3 py-2">
                      <option value="kg">Kilogram (kg)</option>
                      <option value="g">Gram (g)</option>
                      <option value="l">Liter (l)</option>
                      <option value="ml">Milliliter (ml)</option>
                      <option value="pcs">Pieces (pcs)</option>
                    </select>
                  </div>
                );

                let inputType = 'text';
                let label = '';
                if(field==='name') {
                  label = 'Ingredient Name';
                  inputType = 'text';
                } else if(field==='quantity') {
                  label = 'Quantity';
                  inputType = 'number';
                } else if(field==='minThreshold') {
                  label = 'Min Threshold';
                  inputType = 'number';
                }

                return (
                  <div key={field}>
                    <label className="block text-sm font-medium mb-1">{label} *</label>
                    <input
                      type={inputType}
                      step={inputType==='number'? '0.01' : undefined}
                      min={inputType==='number'? '0' : undefined}
                      value={ingredientForm[field] === 0 && inputType==='number' ? '' : ingredientForm[field]}
                      onChange={e=>handleIngredientChange(field,e.target.value)}
                      className="w-full border rounded px-3 py-2"
                    />
                  </div>
                );
              })}

              <div className="flex gap-2">
                <button onClick={handleSaveIngredient} disabled={loading} className="flex-1 bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 disabled:bg-gray-400">
                  {loading? 'Saving...': editingId?'Update':'Add'}
                </button>
                {editingId && <button onClick={()=>{setEditingId(null); setIngredientForm({name:'',unit:'kg',quantity:0,minThreshold:5})}} className="px-4 py-2 border rounded hover:bg-gray-100">Cancel</button>}
              </div>
            </div>
          </div>

          {/* List */}
          <div className="bg-white p-6 rounded-lg shadow max-h-[600px] overflow-y-auto space-y-3">
            {ingredients.length===0?<p className="text-gray-500 text-center py-8">No ingredients yet</p>:ingredients.map(ing=>(
              <div key={ing._id} className={`border rounded p-4 ${ing.quantity<=ing.minThreshold?'border-red-500 bg-red-50':''}`}>
                <div className="flex justify-between items-start mb-2">
                  <div className="flex-1">
                    <h3 className="font-semibold">{ing.name}</h3>
                    <p className="text-sm text-gray-600">Stock: {ing.quantity} {ing.unit} {ing.quantity<=ing.minThreshold && <span className="text-red-600 ml-2">⚠️ Low Stock</span>}</p>
                    <p className="text-xs text-gray-500">Min Threshold: {ing.minThreshold} {ing.unit}</p>
                  </div>
                  <div className="flex gap-2">
                    <button onClick={()=>handleEditIngredient(ing)} className="text-blue-500 hover:text-blue-700 text-sm">Edit</button>
                    <button onClick={()=>handleDeleteIngredient(ing._id)} className="text-red-500 hover:text-red-700 text-sm">Delete</button>
                  </div>
                </div>
                <div className="flex gap-2 mt-2">
                  <input type="number" step="0.01" min="0" placeholder="New quantity" className="flex-1 border rounded px-2 py-1 text-sm"
                    onKeyPress={e=>{if(e.key==='Enter'){handleUpdateStock(ing._id,e.target.value); e.target.value='';}}}/>
                  <button onClick={e=>{const input=e.target.previousSibling; if(input.value){handleUpdateStock(ing._id,input.value); input.value='';}}} className="bg-green-500 text-white px-3 py-1 rounded text-sm hover:bg-green-600">Update</button>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* RECIPES */}
      {activeTab==='recipes' && (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Form */}
          <div className="bg-white p-6 rounded-lg shadow">
            <h2 className="text-xl font-semibold mb-4">{editingRecipeId?'Edit Recipe':'Create Recipe'}</h2>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium mb-1">Menu Item *</label>
                <select value={recipeForm.menuItem} onChange={e=>setRecipeForm({...recipeForm, menuItem:e.target.value})} disabled={editingRecipeId} className="w-full border rounded px-3 py-2">
                  <option value="">Select a menu item</option>
                  {menuItems.map(i=><option key={i._id} value={i._id}>{i.name}</option>)}
                </select>
                {editingRecipeId && <p className="text-xs text-gray-500 mt-1">Menu item cannot be changed when editing</p>}
              </div>
              <div>
                <label className="block text-sm font-medium mb-2">Ingredients *</label>
                {recipeForm.ingredients.map((ing,index)=>{
                  const selIng=ingredients.find(i=>i._id===ing.ingredient);
                  return (
                    <div key={index} className="flex gap-2 mb-2 items-center">
                      <select value={ing.ingredient} onChange={e=>handleRecipeIngredientChange(index,'ingredient',e.target.value)} className="flex-1 border rounded px-2 py-1">
                        <option value="">Select ingredient</option>
                        {ingredients.map(i=><option key={i._id} value={i._id}>{i.name}</option>)}
                      </select>
                      <input type="number" step="0.01" min="0" value={ing.quantity} onChange={e=>handleRecipeIngredientChange(index,'quantity',e.target.value)} placeholder="Qty" className="w-20 border rounded px-2 py-1"/>
                      {selIng && <span className="text-sm text-gray-600 w-10">{selIng.unit}</span>}
                      <button onClick={()=>handleRemoveRecipeIngredient(index)} className="text-red-500 hover:text-red-700 px-2">✕</button>
                    </div>
                  )
                })}
                <button onClick={handleAddRecipeIngredient} className="text-blue-500 hover:text-blue-700 text-sm mt-2">+ Add Ingredient</button>
              </div>
              <button onClick={handleSaveRecipe} disabled={loading} className="w-full bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 disabled:bg-gray-400">{loading? 'Saving...': editingRecipeId?'Update Recipe':'Create Recipe'}</button>
              {editingRecipeId && <button onClick={()=>{setEditingRecipeId(null); setRecipeForm({menuItem:'',ingredients:[]})}} className="w-full border border-gray-300 px-4 py-2 rounded hover:bg-gray-100">Cancel</button>}
            </div>
          </div>

          {/* List */}
          <div className="bg-white p-6 rounded-lg shadow max-h-[600px] overflow-y-auto space-y-4">
            {recipes.length===0?<p className="text-gray-500 text-center py-8">No recipes yet</p>:recipes.map(r=>(
              <div key={r._id} className="border rounded p-4">
                <div className="flex justify-between items-start mb-2">
                  <h3 className="font-semibold">{r.menuItem?.name || 'Unknown Item'}</h3>
                  <div className="flex gap-2">
                    <button onClick={()=>handleEditRecipe(r)} className="text-blue-500 hover:text-blue-700 text-sm">Edit</button>
                    <button onClick={()=>handleDeleteRecipe(r._id)} className="text-red-500 hover:text-red-700 text-sm">Delete</button>
                  </div>
                </div>
                <ul className="list-disc list-inside text-sm text-gray-600 space-y-1">
                  {r.ingredients.map((i,idx)=>(
                    <li key={idx}>{i.ingredient?.name || 'Unknown'}: {i.quantity} {i.ingredient?.unit || ''}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
